import dayjs from "dayjs";
export function useHorseVaccinationHelper() {
    function vaccinationStatusOnDate(vaccination, checkDate, rule = "national", showVaccinationWarning) {
        if (!vaccination ||
            !vaccination.vaccinationDate ||
            !vaccination.calculatedCourseStage) {
            return "invalid";
        }
        if (!checkDate)
            checkDate = dayjs();
        let stateText = "";
        const vaccinationExpiracyWarning = (until, checkDate) => {
            if (!showVaccinationWarning)
                return null;
            const expiracyWarning = dayjs(until).diff(checkDate, "days");
            if (expiracyWarning <= 0)
                return "invalid";
            else if (expiracyWarning <= 7 && expiracyWarning > 0)
                return "allowed_to_compete_with_warning";
            else
                return null;
        };
        switch (rule) {
            case "national":
                {
                    const competingAllowed = dayjs(vaccination.allowsToStartCompetingNationallyFrom) <=
                        dayjs(checkDate);
                    const competeUntilAllowed = dayjs(vaccination.allowsToCompeteNationallyUntil) >=
                        dayjs(checkDate);
                    if (competingAllowed && competeUntilAllowed) {
                        const expiracyState = vaccinationExpiracyWarning(vaccination.allowsToCompeteNationallyUntil, checkDate);
                        if (expiracyState == null)
                            return "allowed_to_compete";
                        else
                            stateText = expiracyState; // return expiracy warning or invalid
                    }
                    else
                        stateText = "invalid";
                }
                break;
            case "international":
                {
                    const competingAllowed = dayjs(vaccination.allowsToStartCompetingInternationallyFrom) <=
                        dayjs(checkDate);
                    const competeUntilAllowed = dayjs(vaccination.allowsToCompeteInternationallyUntil) >=
                        dayjs(checkDate);
                    if (competingAllowed && competeUntilAllowed) {
                        const expiracyState = vaccinationExpiracyWarning(vaccination.allowsToCompeteInternationallyUntil, checkDate);
                        if (expiracyState == null)
                            return "allowed_to_compete";
                        else
                            stateText = expiracyState; // return expiracy warning or invalid
                    }
                    else
                        stateText = "invalid";
                }
                break;
            default:
                stateText = "invalid";
        }
        return stateText;
    }
    return {
        vaccinationStatusOnDate
    };
}
